// The restaurant's chats in the platform agent's panel (D4). Wording from the Amigo design's copy sheet (Chats, Chats
// none); `status` are the chat statuses of docs/platform-agent/contracts.md §6, `who.kinds` who started a chat.
export default {
  title: 'Chats',
  new_chat: 'Nuevo chat',
  note: {
    team: 'Los chats de todos en {{restaurant}}: los tuyos, los de tu equipo y los del restaurante.',
    own: 'Tus chats en {{restaurant}}.',
    // No restaurant selected (D18): the person's own chats started that way.
    no_restaurant:
      'Tus chats sin restaurante seleccionado. Un chat pasa a los chats de un restaurante cuando lo seleccionas.',
  },
  log: 'Todas las solicitudes en el registro de Amigo',
  days: {
    today: 'Hoy',
    yesterday: 'Ayer',
    earlier: 'Anteriores',
  },
  who: {
    you: 'Tú',
    kinds: {
      foodamigos: 'FoodAmigos',
      owner: 'Propietario',
      staff: 'Personal',
      partner: 'Socio',
    },
  },
  status: {
    done: 'Hecho',
    answered: 'Respondido',
    waiting: 'Pendiente de aprobación',
    partial: '{{applied}} de {{total}} aplicados',
    rejected: 'Rechazado',
    not_yet: 'Aún no se pudo hacer',
    failed: 'Error',
  },
  none: {
    title: 'Aún no hay chats para {{restaurant}}',
    title_no_restaurant: 'Aún no hay chats sin restaurante seleccionado',
    text: 'Los chats que inicies aquí se quedan aquí, así podrás volver a ellos.',
  },
  loading: 'Cargando los chats…',
  loading_more: 'Cargando más chats…',
  load_failed: 'No se pudieron cargar los chats.',
  retry: 'Reintentar',
  // A chat with answers the person hasn't read (QA45), before its last line.
  new_answers_one: 'Nueva respuesta:',
  new_answers_other: 'Nuevas respuestas:',
};
